import {
  RecurrenceTimeSlotPayload,
  VisibilityRecurrenceRulePayload,
} from './visibility-recurrence.models';

/**
 * Resolves time windows for evaluation (supports legacy startTime/endTime).
 */
export function normalizeRecurrenceTimeSlots(
  rule: VisibilityRecurrenceRulePayload,
): RecurrenceTimeSlotPayload[] {
  if (Array.isArray(rule.timeSlots) && rule.timeSlots.length > 0) {
    return rule.timeSlots.map(s => ({
      startTime: String(s.startTime ?? '00:00'),
      endTime: String(s.endTime ?? '23:59'),
    }));
  }
  const st = rule.startTime;
  const en = rule.endTime;
  if (typeof st === 'string' && typeof en === 'string') {
    return [{ startTime: st, endTime: en }];
  }
  return [];
}
